import styled from 'styled-components'

export const SoldOut = styled.span`
  color: ${o => o.theme.color.deprecated.red.error};
  margin-left: ${o => o.theme.spacing(1)};
`
